import { leadStory, leadSide, peopleCats } from "@/mocks/gossip";

export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      {/* subtle editorial wash */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-primary-50/70 via-background-50 to-accent-50/60" />

      <div className="relative mx-auto max-w-7xl px-4 py-8 md:px-6 md:py-12">
        {/* breadcrumb-line */}
        <div className="mb-6 flex flex-wrap items-center gap-x-3 gap-y-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1 text-primary-600">
            <i className="ri-news-line"></i>编辑部
          </span>
          <span className="h-3 w-px bg-background-300"></span>
          <span>{leadStory.kicker}</span>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          {/* text-first lead column */}
          <article className="lg:col-span-8">
            <div className="flex flex-wrap gap-2">
              {leadStory.tags.map((t) => (
                <span
                  key={t}
                  className="chip bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900"
                >
                  #{t}
                </span>
              ))}
              <span className="chip bg-primary-100 px-2.5 py-0.5 text-xs text-primary-700">
                <i className="ri-fire-fill"></i>热度飙升
              </span>
            </div>

            <h2 className="mt-4 font-heading text-3xl font-black leading-snug text-foreground-950 md:text-[2.6rem] md:leading-tight">
              {leadStory.title}
            </h2>

            <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-foreground-600 md:text-base">
              {leadStory.summary}
            </p>

            <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
              <span>{leadStory.meta}</span>
              <span className="flex items-center gap-1 text-primary-600">
                <i className="ri-arrow-right-line"></i>阅读全文
              </span>
            </div>

            {/* muted stat strip for community mood */}
            <div className="mt-6 flex max-w-2xl flex-wrap gap-x-8 gap-y-3 border-t border-background-200 pt-5">
              {[
                { k: "围观中", v: "128.4万" },
                { k: "参与讨论", v: "6.2万" },
                { k: "涨粉曲线", v: "+318%" },
                { k: "站队比", v: "58 : 42" },
              ].map((s) => (
                <div key={s.k}>
                  <div className="font-label text-[11px] text-foreground-400">{s.k}</div>
                  <div className="font-heading text-lg font-bold text-foreground-950">{s.v}</div>
                </div>
              ))}
            </div>
          </article>

          {/* side quick leads */}
          <aside className="flex flex-col gap-3 lg:col-span-4 lg:border-l lg:border-background-200 lg:pl-6">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-base font-bold text-foreground-950">跟紧围观</h3>
              <a href="#feed" className="flex items-center gap-1 text-xs text-primary-600 hover:text-primary-700">
                更多 <i className="ri-arrow-right-s-line"></i>
              </a>
            </div>
            {leadSide.map((s, i) => (
              <a
                key={s.id}
                href="#feed"
                className="group flex gap-3 rounded-lg border border-background-200 bg-background-50/80 p-3 transition-colors hover:border-primary-300"
              >
                <span className="grid h-7 w-7 shrink-0 items-center justify-center rounded-md bg-background-200 font-heading text-sm font-bold text-secondary-800">
                  {i + 1}
                </span>
                <div className="min-w-0">
                  <span className="chip bg-primary-100 px-1.5 py-px text-[11px] text-primary-700">{s.cat}</span>
                  <p className="mt-1.5 text-sm font-medium leading-snug text-foreground-800 transition-colors group-hover:text-primary-700">
                    {s.title}
                  </p>
                  <span className="mt-1 block text-[11px] text-foreground-400">
                    <i className="ri-chat-3-line"></i> {s.meta}
                  </span>
                </div>
              </a>
            ))}
            <div className="mt-1 flex flex-wrap items-center gap-2">
              {peopleCats.map((c, idx) => (
                <a
                  key={c}
                  href="#feed"
                  className="chip border border-background-200 bg-background-50 px-3 py-1.5 text-xs text-foreground-600 transition-colors hover:border-accent-400 hover:bg-accent-50 hover:text-accent-800"
                >
                  {c}
                  <span className="text-foreground-300">/{idx + 4}</span>
                </a>
              ))}
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}